import { useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { StatsModuleProps, Stats } from "@/patterns/adg4/stats/src/stats";

export const StatsSection = () => {
    const intl = useIntl();

    const statsProps: StatsModuleProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage:
                    "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: "#1868DB",
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: "#1868DB"
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage:
                        "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: "#1868DB",
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: "#1868DB"
                }
            },
            {
                stat: "79",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2",
                    defaultMessage:
                        "of enterprise customers are satisfied with Atlassian cloud products"
                }),
                statColor: "#1868DB",
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: "#1868DB"
                }
            }
        ]
    };

    return (
        <UFOSegment name="enterprise-page-stats">
            <section>
                <Stats {...statsProps} />
            </section>
        </UFOSegment>
    );
};
